import axios from 'axios';

// Zones with no units must not appear anywhere in the app. Every view is fed
// from these three endpoints (the slices dispatched in Mainpage.js and the
// react-query caches in EssMain/TgsMain/TesMain), so pruning here is what keeps
// the zone lists consistent across select boxes, master control, settings,
// report status, the global overview and the PDF export.
//
// Structured payload shape:
//   { zone_id, zone_name, ..., devices: [...] }
//   { zone_id, zone_name, ..., specific_location: [ { zone_id, devices: [...] } ] }

// Drops sub-locations left with no units, then any zone left with nothing.
// Every device the endpoint returns is kept: a panel that has never reported
// carries fewer fields than one that has, but it is still configured hardware
// the location is expected to show.
const pruneEmptyZones = (zones) =>
  (zones || [])
    .map((zone) => {
      if (zone?.specific_location) {
        const specificLocation = zone.specific_location.filter(
          (subLocation) => (subLocation?.devices || []).length > 0,
        );

        return specificLocation.length > 0
          ? { ...zone, specific_location: specificLocation }
          : null;
      }

      return (zone?.devices || []).length > 0 ? zone : null;
    })
    .filter(Boolean);

// The flat (unstructured) payload is not a zone tree, so it is passed through.
const prune = (data, params) =>
  params?.structured ? pruneEmptyZones(data) : data;

export const getEssZones = async (params) => {
  try {
    const response = await axios.get('/get-zones/switches', { params });
    return prune(response.data, params);
  } catch (error) {
    throw error;
  }
};

export const getTgsZones = async (params) => {
  try {
    const response = await axios.get('/get-zones/blowers', { params });
    return prune(response.data, params);
  } catch (error) {
    throw error;
  }
};

export const getTesZones = async (params) => {
  try {
    const response = await axios.get('/get-zones/blowers', { params:{
      type:"TES",
      ...params
    } });
    return prune(response.data, params);
  } catch (error) {
    throw error;
  }
};

export const uploadSiteMapService = async (
  zoneId,
  switchType,
  siteMapArray,
  specificZoneId
) => {
  try {
    const response = await axios.patch(`/zones/${zoneId}`, {
      ...(switchType === 'ess' && {
        site_maps_ESS: siteMapArray,
      }),
      ...(switchType === 'tes' && {
        site_maps_TES: siteMapArray,
      }),
      ...(switchType === 'tgs' && {
        site_maps_TGS: siteMapArray,
      }),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
